import React, { ReactNode } from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import OnboardingWizardStepsSection from './OnboardingWizardStepsSection/OnboardingWizardStepsSection';
import './OnboardingWizardPageWrapper.scss';

type Props = {
  children: ReactNode;
};

function OnboardingWizardPageWrapper({ children }: Props) {
  return (
    <div className="onboarding-wizard-page-wrapper d-flex flex-row flex-column">
      <div className="onboarding-wizard-page-wrapper-title pt-4 d-flex flex-column flex-lg-row justify-content-between">
        <CharmaLogo width="230" className="mt-2 ml-0 ml-4 ml-lg-5 align-self-lg-start" />
        <OnboardingWizardStepsSection />
      </div>
      {children}
    </div>
  );
}

export default OnboardingWizardPageWrapper;
